module.exports = __webpack_public_path__ + "img/dashboard_info_logo.67f27b01.svg";